import MoneyInput from 'common/components/moneyInput/MoneyInput';
import { BudgetLineParameterDto } from 'api/budgets/models/BudgetLineParameterDto';
import { useDispatch } from 'react-redux';
import { updateLineQuantity } from 'store/budget/action';
import { BudgetLineDto } from 'api/budgets/models/BudgetDto';
import { useContext } from 'react';
import { LinesDataProvider } from '../../../../LinesDataProvider';
import ExpressionSystem from 'common/components/expressionButton/ExpressionSystem';
import { getExpressionParameters } from '../../../../utils';

interface Props {
    parameter: BudgetLineParameterDto;
    line: BudgetLineDto;
    disabled: boolean;
    onChange: (parameter: Partial<BudgetLineParameterDto>, calculateTotals: boolean) => void;
}

function ParameterQuantity({ parameter, line, disabled, onChange }: Props): JSX.Element | null {
    const dispatch = useDispatch();
    const { units } = useContext(LinesDataProvider);
    const unitsOptions = units.map(u => ({ selectedLabel: u.symbol, label: u.name, value: u.id }));

    const handleOnChange = (value: number | null | undefined, expression: string | null | undefined) => {
        onChange({ quantity: { ...(parameter.quantity ?? {}), quantity: value ?? 0, quantityExpression: expression } }, false); // false because updateLineQuantity takes care of that
        dispatch(updateLineQuantity(line.key));
    }

    return (
        <MoneyInput
            value={parameter.quantity?.quantity ?? null}
            onBlur={v => {
                const tolerance = 0.000001;
                const currentValue = parameter.quantity?.quantity ?? 0;
                const newValue = v ?? 0;
                const isDifferent = Math.abs(currentValue - newValue) > tolerance;
                handleOnChange(v, isDifferent ? null : parameter.quantity?.quantityExpression);
            }}
            unitPrefix={unitsOptions.find(x => x.value === line.unitId)?.selectedLabel}
            disabled={disabled}
            expressionButton={{
                title: ExpressionSystem.formatParameterName([parameter.parameterName ?? '']),
                value: parameter.quantity?.quantityExpression ?? '',
                loadParameters: () => getExpressionParameters(line.key),
                onChange: (expr, value) => handleOnChange(value ?? 0, expr)
            }}
        />
    );
}

export default ParameterQuantity;
